module.exports = __webpack_public_path__ + "img/arrow-left.e41b3035.svg";